import { useState, useEffect, useRef } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const services = [
  {
    icon: 'ri-trophy-line',
    number: '01',
    title: 'Consultoria Esportiva',
    subtitle: 'Gestão de Carreira & Assessoria Internacional',
    description:
      'Assessoria completa para atletas profissionais que desejam maximizar o valor de sua carreira. Nossa equipe de especialistas atua em todas as frentes: gestão de contratos, negociação com clubes nacionais e internacionais, planejamento de carreira a longo prazo e posicionamento de marca pessoal.',
    features: [
      'Negociação e revisão de contratos esportivos',
      'Gestão de imagem e marca pessoal',
      'Transferências internacionais',
      'Planejamento de carreira pós-atleta',
      'Assessoria em patrocínios e endorsements',
    ],
    image: 'https://public.readdy.ai/ai/img_res/c1594f78f56c27e26c196ba644dd9cb7.jpg',
  },
  {
    icon: 'ri-safe-2-line',
    number: '02',
    title: 'Blindagem Patrimonial',
    subtitle: 'Proteção & Estruturação Jurídica Internacional',
    description:
      'Estruturas jurídicas e financeiras robustas para proteger o patrimônio construído com tanto esforço. Utilizamos as melhores práticas internacionais para garantir que seus ativos estejam seguros contra riscos fiscais, jurídicos e sucessórios.',
    features: [
      'Criação de holdings nacionais e internacionais',
      'Trusts e estruturas offshore',
      'Planejamento tributário sofisticado',
      'Proteção contra ações judiciais',
      'Planejamento sucessório e heranças',
    ],
    image: 'https://readdy.ai/api/search-image?query=financial%20legal%20document%20signing%20luxury%20office%20corporate%20protection%20shield%20vault%20wealth%20management%20sophisticated%20dark%20interior%20premium%20professional%20legal%20counsel%20international%20law&width=700&height=500&seq=serv-img-02&orientation=landscape',
  },
  {
    icon: 'ri-bit-coin-line',
    number: '03',
    title: 'Operações Financeiras e Cripto',
    subtitle: 'Ativos Digitais & Mercados Internacionais',
    description:
      'Navegar no mundo das criptomoedas e dos mercados financeiros internacionais exige conhecimento especializado e timing preciso. Nossa equipe oferece suporte completo para operações com ativos digitais e diversificação de investimentos.',
    features: [
      'Operações com Bitcoin e principais criptomoedas',
      'DeFi e yield strategies',
      'Custódia segura de ativos digitais',
      'Diversificação em mercados internacionais',
      'Compliance e regularização fiscal de cripto',
    ],
    image: 'https://readdy.ai/api/search-image?query=cryptocurrency%20bitcoin%20trading%20luxury%20dark%20office%20multiple%20screens%20financial%20data%20charts%20professional%20crypto%20trader%20premium%20workstation%20sophisticated%20technology%20fintech%20high%20end%20setup%20glowing&width=700&height=500&seq=serv-img-03&orientation=landscape',
  },
  {
    icon: 'ri-star-line',
    number: '04',
    title: 'Grandes Eventos',
    subtitle: 'Planejamento & Gestão de Alto Nível',
    description:
      'Concepção, planejamento e execução de grandes eventos esportivos e corporativos com padrão internacional de excelência. De jogos beneficentes a eventos corporativos de alto impacto, entregamos experiências memoráveis.',
    features: [
      'Eventos esportivos de grande porte',
      'Eventos corporativos internacionais',
      'Festivais e showbiz',
      'Gestão de venue e logística premium',
      'Coordenação de atletas e celebridades',
    ],
    image: 'https://readdy.ai/api/search-image?query=luxury%20corporate%20gala%20event%20premium%20venue%20elegant%20decoration%20sophisticated%20atmosphere%20gold%20lighting%20international%20business%20event%20ceremony%20high%20end%20setup%20exclusive%20gathering%20dark&width=700&height=500&seq=serv-img-04&orientation=landscape',
  },
];

const SCHEMA_SERVICOS = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/servicos/#webpage`,
      url: `${import.meta.env.VITE_SITE_URL}/servicos/`,
      name: 'Serviços | LOPES BUSINESS - Consultoria Esportiva e Blindagem Patrimonial',
      description:
        'Conheça os serviços da LOPES BUSINESS: Consultoria Esportiva, Blindagem Patrimonial, Operações Financeiras e Cripto, e Grandes Eventos. Soluções exclusivas para atletas e empresários.',
      inLanguage: 'pt-BR',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL}/servicos/#consultoria-esportiva`,
      name: 'Consultoria Esportiva',
      description:
        'Assessoria completa para atletas profissionais: gestão de contratos, negociação com clubes nacionais e internacionais, planejamento de carreira e posicionamento de marca pessoal.',
      provider: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      areaServed: 'Worldwide',
      serviceType: 'Consultoria Esportiva',
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL}/servicos/#blindagem-patrimonial`,
      name: 'Blindagem Patrimonial',
      description:
        'Estruturas jurídicas e financeiras robustas para proteger o patrimônio: holdings, trusts, planejamento tributário sofisticado e planejamento sucessório.',
      provider: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      areaServed: 'Worldwide',
      serviceType: 'Blindagem Patrimonial Internacional',
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL}/servicos/#operacoes-financeiras`,
      name: 'Operações Financeiras e Cripto',
      description:
        'Suporte completo para operações com ativos digitais, criptomoedas, DeFi, custódia segura e diversificação em mercados internacionais.',
      provider: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      areaServed: 'Worldwide',
      serviceType: 'Operações Financeiras Internacionais',
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL}/servicos/#grandes-eventos`,
      name: 'Grandes Eventos',
      description:
        'Concepção, planejamento e execução de grandes eventos esportivos e corporativos com padrão internacional de excelência.',
      provider: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      areaServed: 'Worldwide',
      serviceType: 'Gestão de Grandes Eventos',
    },
  ],
};

const ServicosPage = () => {
  const [activeService, setActiveService] = useState(0);
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const id = 'schema-servicos';
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(SCHEMA_SERVICOS);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.1 }
    );
    const elements = ref.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));
    return () => {
      observer.disconnect();
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea');
    if (textarea && textarea.value.length > 500) {
      alert('A mensagem não pode ultrapassar 500 caracteres.');
      return;
    }
    setFormStatus('sending');
    const formData = new URLSearchParams();
    const elements = form.elements;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (el.name) {
        if (el.type === 'checkbox') {
          if ((el as HTMLInputElement).checked) formData.append(el.name, el.value);
        } else {
          formData.append(el.name, el.value);
        }
      }
    }
    try {
      const res = await fetch('https://readdy.ai/api/form/d726bu0hb0rqicn68tb0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (res.ok) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
      }
    } catch {
      setFormStatus('error');
    }
  };

  return (
    <div className="bg-[#0B0B0D] min-h-screen" ref={ref}>
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-40 pb-24 overflow-hidden"
        style={{ background: 'linear-gradient(180deg, #0F172A 0%, #0B0B0D 100%)' }}
      >
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=international%20financial%20district%20city%20night%20luxury%20skyline%20dark%20sophisticated%20corporate%20world%20global%20business%20premium%20architecture%20modern%20glass%20buildings%20reflections%20dramatic%20lighting&width=1920&height=600&seq=servicos-hero-01&orientation=landscape"
            alt="Serviços LOPES BUSINESS"
            className="w-full h-full object-cover object-top opacity-10"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/80 to-[#0B0B0D]"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#06B6D4] block mb-4 reveal opacity-0 translate-y-10 transition-all duration-700">
            O que Fazemos
          </span>
          <h1 className="font-serif text-5xl md:text-7xl font-light text-white mb-6 reveal opacity-0 translate-y-10 transition-all duration-700 delay-100"
            style={{ textShadow: '0 0 60px rgba(30,58,138,0.4)' }}
          >
            Nossos <span className="italic text-[#C9A96E]">Serviços</span>
          </h1>
          <p className="font-sans text-base md:text-lg font-light text-[#D1D5DB]/70 max-w-2xl mx-auto leading-relaxed reveal opacity-0 translate-y-10 transition-all duration-700 delay-200">
            Soluções estratégicas e exclusivas para atletas e empresários de alta performance
            que buscam excelência, segurança e alcance global.
          </p>
        </div>
      </section>

      {/* Service Selector Tabs */}
      <section className="sticky top-20 z-30 bg-[#0B0B0D]/95 backdrop-blur-md border-b border-[#1E3A8A]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center gap-0 overflow-x-auto scrollbar-hide">
            {services.map((s, i) => (
              <button
                key={i}
                onClick={() => setActiveService(i)}
                className={`flex-shrink-0 flex items-center gap-3 px-6 py-5 border-b-2 transition-all duration-300 cursor-pointer whitespace-nowrap font-sans text-sm font-medium tracking-wide ${
                  activeService === i
                    ? 'border-[#C9A96E] text-[#C9A96E]'
                    : 'border-transparent text-[#D1D5DB]/50 hover:text-[#D1D5DB]/80'
                }`}
              >
                <i className={`${s.icon} text-base`}></i>
                {s.title}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Service Detail */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {services.map((service, i) => (
            <div
              key={i}
              className={`transition-all duration-500 ${activeService === i ? 'block' : 'hidden'}`}
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                <div>
                  <div className="mb-6">
                    <span className="font-serif text-8xl font-light"
                      style={{ color: 'rgba(201,169,110,0.15)' }}
                    >
                      {service.number}
                    </span>
                  </div>
                  <div className="w-14 h-14 flex items-center justify-center rounded-full border border-[#C9A96E]/30 mb-6"
                    style={{ background: 'rgba(201,169,110,0.05)' }}
                  >
                    <i className={`${service.icon} text-[#C9A96E] text-2xl`}></i>
                  </div>
                  <h2 className="font-serif text-4xl md:text-5xl font-light text-white mb-3">
                    {service.title}
                  </h2>
                  <p className="font-sans text-sm font-medium tracking-widest uppercase text-[#06B6D4] mb-8">
                    {service.subtitle}
                  </p>
                  <p className="font-sans text-base font-light text-[#D1D5DB]/70 leading-relaxed mb-10">
                    {service.description}
                  </p>
                  <ul className="flex flex-col gap-3">
                    {service.features.map((feature, fi) => (
                      <li key={fi} className="flex items-center gap-3">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-checkbox-circle-line text-[#C9A96E] text-lg"></i>
                        </div>
                        <span className="font-sans text-sm font-light text-[#D1D5DB]/80">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-10">
                    <a
                      href="https://wa.me/qr/KP7ZNZ7ZYHHCN1"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="inline-flex items-center gap-3 font-sans text-sm font-semibold tracking-widest uppercase bg-[#C9A96E] text-[#0B0B0D] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
                      style={{ boxShadow: '0 0 30px rgba(201,169,110,0.25)' }}
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                      Solicitar Consultoria
                    </a>
                  </div>
                </div>
                <div>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[520px] object-cover object-top rounded-2xl"
                    style={{ boxShadow: '0 0 60px rgba(30,58,138,0.25)' }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-24 lg:py-32 bg-[#0F172A]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <div className="reveal opacity-0 translate-y-10 transition-all duration-700">
              <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#06B6D4] block mb-4">
                Fale Conosco
              </span>
              <h2 className="font-serif text-5xl md:text-6xl font-light text-white mb-4"
                style={{ textShadow: '0 0 40px rgba(30,58,138,0.3)' }}
              >
                Entre em <span className="italic text-[#C9A96E]">Contato</span>
              </h2>
              <div className="w-16 h-px bg-[#C9A96E] mx-auto mt-6 mb-6"></div>
              <p className="font-sans text-base font-light text-[#D1D5DB]/60 leading-relaxed">
                Todas as conversas são tratadas com absoluta confidencialidade.
                Nossa equipe responderá em breve.
              </p>
            </div>
          </div>

          <div className="reveal opacity-0 translate-y-10 transition-all duration-700 delay-100">
            <div className="p-8 md:p-12 rounded-2xl border border-[#1E3A8A]/30"
              style={{ background: 'rgba(11,11,13,0.8)' }}
            >
              {formStatus === 'success' ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-full border border-[#C9A96E]/30">
                    <i className="ri-check-line text-[#C9A96E] text-3xl"></i>
                  </div>
                  <h3 className="font-serif text-2xl font-light text-white mb-3">Mensagem Enviada</h3>
                  <p className="font-sans text-sm font-light text-[#D1D5DB]/60">
                    Nossa equipe entrará em contato em breve. Obrigado pelo interesse.
                  </p>
                  <button
                    onClick={() => setFormStatus('idle')}
                    className="mt-8 font-sans text-sm font-medium tracking-widest uppercase border border-[#C9A96E]/40 text-[#C9A96E] px-8 py-3 rounded-full hover:bg-[#C9A96E] hover:text-[#0B0B0D] transition-all duration-300 cursor-pointer"
                  >
                    Nova Mensagem
                  </button>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col gap-2">
                      <label className="font-sans text-xs font-medium tracking-widest uppercase text-[#D1D5DB]/50">
                        Nome Completo
                      </label>
                      <input
                        type="text"
                        name="nome"
                        required
                        placeholder="Seu nome"
                        className="bg-[#0F172A] border border-[#1E3A8A]/40 rounded-lg px-4 py-3 font-sans text-sm text-white placeholder-[#D1D5DB]/30 focus:outline-none focus:border-[#C9A96E]/50 transition-colors duration-300"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-sans text-xs font-medium tracking-widest uppercase text-[#D1D5DB]/50">
                        E-mail
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="seu@email.com"
                        className="bg-[#0F172A] border border-[#1E3A8A]/40 rounded-lg px-4 py-3 font-sans text-sm text-white placeholder-[#D1D5DB]/30 focus:outline-none focus:border-[#C9A96E]/50 transition-colors duration-300"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col gap-2">
                      <label className="font-sans text-xs font-medium tracking-widest uppercase text-[#D1D5DB]/50">
                        Telefone / WhatsApp
                      </label>
                      <input
                        type="tel"
                        name="telefone"
                        placeholder="+55 (11) 99999-9999"
                        className="bg-[#0F172A] border border-[#1E3A8A]/40 rounded-lg px-4 py-3 font-sans text-sm text-white placeholder-[#D1D5DB]/30 focus:outline-none focus:border-[#C9A96E]/50 transition-colors duration-300"
                      />
                    </div>
                    <div className="flex flex-col gap-2">
                      <label className="font-sans text-xs font-medium tracking-widest uppercase text-[#D1D5DB]/50">
                        Serviço de Interesse
                      </label>
                      <select
                        name="servico"
                        required
                        className="bg-[#0F172A] border border-[#1E3A8A]/40 rounded-lg px-4 py-3 font-sans text-sm text-white focus:outline-none focus:border-[#C9A96E]/50 transition-colors duration-300 cursor-pointer"
                      >
                        <option value="" className="bg-[#0F172A]">Selecione...</option>
                        <option value="consultoria-esportiva" className="bg-[#0F172A]">Consultoria Esportiva</option>
                        <option value="blindagem-patrimonial" className="bg-[#0F172A]">Blindagem Patrimonial</option>
                        <option value="operacoes-financeiras" className="bg-[#0F172A]">Operações Financeiras e Cripto</option>
                        <option value="grandes-eventos" className="bg-[#0F172A]">Grandes Eventos</option>
                        <option value="geral" className="bg-[#0F172A]">Consulta Geral</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="font-sans text-xs font-medium tracking-widest uppercase text-[#D1D5DB]/50">
                      Mensagem <span className="normal-case tracking-normal text-[#D1D5DB]/30">(máx. 500 caracteres)</span>
                    </label>
                    <textarea
                      name="mensagem"
                      required
                      rows={5}
                      maxLength={500}
                      placeholder="Descreva brevemente como podemos ajudá-lo..."
                      className="bg-[#0F172A] border border-[#1E3A8A]/40 rounded-lg px-4 py-3 font-sans text-sm text-white placeholder-[#D1D5DB]/30 focus:outline-none focus:border-[#C9A96E]/50 transition-colors duration-300 resize-none"
                    ></textarea>
                  </div>
                  {formStatus === 'error' && (
                    <p className="font-sans text-xs text-red-400">Erro ao enviar. Tente novamente ou entre em contato via WhatsApp.</p>
                  )}
                  <div className="flex items-center justify-between flex-wrap gap-4 pt-2">
                    <p className="font-sans text-xs font-light text-[#D1D5DB]/40 flex items-center gap-2">
                      <i className="ri-lock-2-line text-[#C9A96E]"></i>
                      Atendimento 100% confidencial
                    </p>
                    <button
                      type="submit"
                      disabled={formStatus === 'sending'}
                      className="font-sans text-sm font-semibold tracking-widest uppercase bg-[#C9A96E] text-[#0B0B0D] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                      style={{ boxShadow: '0 0 25px rgba(201,169,110,0.25)' }}
                    >
                      {formStatus === 'sending' ? 'Enviando...' : 'Enviar Mensagem'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ServicosPage;
